import { Logo } from 'components/Logo'
import PropTypes from 'prop-types'
import React from 'react'
// import src from '../../images/icon-logo-blue.svg'
import src from '../../images/logo.png'

const Hexagon = (props) => {
  return <Logo src={src} alt="ADAMoracle Operator" {...props} />
}

Hexagon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
}

export default Hexagon
